<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { deepCopy } from 'src/helpers/utilities';
	//Design system components
	import { Button, Container, Modal } from '@Shelly/shelly-design-system';
	//Types
	import type { VirtualComponentInterface, VirtualComponentTypes } from 'src/types/VirtualComponents';
	import VCSettings from './VCSettings.svelte';

	export let component: VirtualComponentInterface;
	export let showModal: boolean;
	export let waitForResponse = false;

	let settingsError = false;
	let settings = deepCopy(component.config);
	let editEnumModal = false;

	const dispatcher = createEventDispatcher();
	const key = component.key;
	const type: VirtualComponentTypes = key.split(':')[0] as VirtualComponentTypes;
</script>

<Modal
	{showModal}
	on:close={() => (showModal = false)}
	title={$format('virtual_component_modal_settings', {
		default: 'Virtual Component Settings',
	})}
	removeScrollPadding
>
	<svelte:fragment slot="content">
		<Container padding="scrollPaddings">
			<VCSettings bind:settings bind:settingsError bind:editEnumModal {type} component={key} />
		</Container>
	</svelte:fragment>
	<div class="d-flex justify-content-end" slot="footer">
		{#if !editEnumModal}
			<Button
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
				responsiveSize={{
					sm: 'm',
				}}
				variant="secondary"
				on:click={() => (showModal = false)}
			>
				{$format('button_cancel', { default: 'Cancel' })}
			</Button>
			<Button
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap "
				responsiveSize={{
					sm: 'm',
				}}
				disabled={settingsError || waitForResponse}
				loading={waitForResponse}
				on:click={() => dispatcher('edit', { settings, type, key })}
			>
				{$format('button_save', { default: 'Save' })}
			</Button>
		{/if}
	</div>
</Modal>
